import { ApiResponse, getFromServer, postToServer, BASE_URL } from "server";
import {
  CreateStartupAdminOutput,
  GetAllStartupAdminsOutput,
  GetSubmissionsOutput,
  GetTeachersOutput,
  GetUsersOutput,
} from "../OutputsTypes";
import {
  CreateStartupAdminInput,
  UpdateCorrectorOrSupervisorInput,
  RejectExerciseInput,
} from "../InputsTypes";

// Route : GET /startup-admins/all
export const getAllStartupAdmins = async (): Promise<
  ApiResponse<GetAllStartupAdminsOutput[]>
> => {
  return await getFromServer<GetAllStartupAdminsOutput[]>(
    "/startup-admins/all",
  );
};

// Route : POST /startup-admins/create
export const createStartupAdmin = async (
  input: CreateStartupAdminInput,
): Promise<ApiResponse<CreateStartupAdminOutput>> => {
  return await postToServer<CreateStartupAdminInput, CreateStartupAdminOutput>(
    "/startup-admins/create",
    input,
  );
};

export const getSubmissions = async (): Promise<
  ApiResponse<GetSubmissionsOutput[]>
> => {
  return await getFromServer<GetSubmissionsOutput[]>("/problems/all");
};

export const getSubmissionsForTeacher = async (): Promise<
  ApiResponse<GetSubmissionsOutput[]>
> => {
  return await getFromServer<GetSubmissionsOutput[]>("/problems/mine");
};

// Route: GET problems/{exerciseId}
export const getSubmissionById = async (
  exerciseId: string,
): Promise<ApiResponse<GetSubmissionsOutput>> => {
  return await getFromServer<GetSubmissionsOutput>(`/problems/${exerciseId}`);
};

// Route: POST problems/{exerciseId}/update-corrector-or-supervisor
export const updateCorrectorOrSupervisor = async (
  exerciseId: string,
  input: UpdateCorrectorOrSupervisorInput,
): Promise<ApiResponse<GetSubmissionsOutput>> => {
  return await postToServer<
    UpdateCorrectorOrSupervisorInput,
    GetSubmissionsOutput
  >(`/problems/${exerciseId}/update-corrector-or-supervisor`, input);
};

// Route: POST problems/{exerciseId}/activate
export const activateExercise = async (
  exerciseId: string,
): Promise<ApiResponse<GetSubmissionsOutput>> => {
  return await postToServer<{}, GetSubmissionsOutput>(
    `/problems/${exerciseId}/activate`,
    {},
  );
};

// Route: POST problems/{exerciseId}/reject
export const rejectExercise = async (
  exerciseId: string,
  input: RejectExerciseInput,
): Promise<ApiResponse<GetSubmissionsOutput>> => {
  return await postToServer<RejectExerciseInput, GetSubmissionsOutput>(
    `/problems/${exerciseId}/reject`,
    input,
  );
};

// Route: GET teachers/all
export const getTeachers = async (): Promise<
  ApiResponse<GetTeachersOutput[]>
> => {
  return await getFromServer<GetTeachersOutput[]>("/teachers/all");
};

// Route: GET users/all
export const getUsers = async (): Promise<ApiResponse<GetUsersOutput[]>> => {
  return await getFromServer<GetUsersOutput[]>("/users/all");
};

// Route: POST /students/create/in-school/from-spreadsheet
export const createStudentsInSchoolFromSpreadsheet = async (
  file: File,
  schoolName: string,
): Promise<ApiResponse<Blob>> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("school", schoolName);

  try {
    const response = await fetch(
      `${BASE_URL}/students/create/in-school/from-spreadsheet`,
      {
        method: "POST",
        body: formData,
        credentials: "include",
      },
    );

    if (response.ok) {
      const blob = await response.blob();
      return {
        status: 200,
        body: blob,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: new Blob(
          [
            JSON.stringify({
              message: errorData.message || "Une erreur est survenue",
            }),
          ],
          { type: "application/json" },
        ),
      };
    }
  } catch (error) {
    console.error("Erreur lors de l'upload:", error);
    return {
      status: 500,
      body: new Blob(
        [JSON.stringify({ message: "Erreur interne du serveur" })],
        { type: "application/json" },
      ),
    };
  }
};
